import { createFileRoute } from '@tanstack/react-router';
import { googleLoginUrl } from '@/lib/auth';

export const Route = createFileRoute('/login')({
  component: LoginPage,
  validateSearch: (search: Record<string, unknown>) => ({
    error: typeof search.error === 'string' ? search.error : undefined,
    email: typeof search.email === 'string' ? search.email : undefined,
  }),
});

function LoginPage() {
  const { error, email } = Route.useSearch();

  return (
    <div className="flex min-h-screen items-center justify-center bg-light-gray px-6">
      <div className="w-full max-w-md rounded-card bg-soft-white p-8 shadow-card">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-tech-blue text-xl font-semibold text-soft-white">
            E
          </div>
          <h1 className="text-h1">Explorentia Admin</h1>
          <p className="mt-2 text-body text-slate-gray">
            Sign in with your Google account. Access is restricted to whitelisted staff.
          </p>
        </div>

        {error === 'not_authorized' ? (
          <div className="mb-5 rounded-lg border border-error/30 bg-error/10 p-4 text-caption text-dark-navy">
            <p className="font-semibold text-error">Access denied</p>
            <p className="mt-1">
              The Google account
              {email ? (
                <>
                  {' '}
                  <span className="font-mono">{email}</span>
                </>
              ) : null}{' '}
              is not in the admin whitelist. Ask an existing admin to add you.
            </p>
          </div>
        ) : null}

        <a href={googleLoginUrl()} className="btn-primary w-full">
          <svg className="mr-2 h-4 w-4" viewBox="0 0 48 48" aria-hidden>
            <path
              fill="#FFC107"
              d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.3 6.3 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"
            />
            <path
              fill="#FF3D00"
              d="M6.3 14.1l6.6 4.8C14.7 15 19 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.3 6.3 29.4 4 24 4 16.3 4 9.7 8.3 6.3 14.1z"
            />
            <path
              fill="#4CAF50"
              d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.3C29.2 35.1 26.7 36 24 36c-5.2 0-9.7-3.3-11.3-8l-6.6 5.1C9.6 39.6 16.2 44 24 44z"
            />
            <path
              fill="#1976D2"
              d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-3.9 5.5l6.3 5.3C41.4 36 44 30.5 44 24c0-1.3-.1-2.3-.4-3.5z"
            />
          </svg>
          Sign in with Google
        </a>

        <p className="mt-6 text-center text-caption text-slate-gray">
          Restricted area — you&apos;ll be redirected to Google and back.
        </p>
      </div>
    </div>
  );
}
